<ng-container [formGroup]="form">
  <nz-form-item *ngIf="env.captcha"
                [ngClass]="{'has-error': form.controls.captcha.dirty && form.controls.captcha.errors,
                            'margin-recaptcha':true}">
    <nz-form-control>
      <div class="g-recaptcha">
        <div [ngClass]="{'loading-bar': isVerifyingInternally}">
          <re-captcha
            formControlName="captcha"
            [siteKey]="CAPTCHA_SITE_KEY"
            (resolved)="captchaResolved($event)">
          </re-captcha>
        </div>
        <div *ngIf="form.controls.captcha?.dirty && form.controls.captcha.errors
            && form.controls.captcha.errors.required"
             class="mimic-zorro-error-tip"> Please verify
        </div>
      </div>
    </nz-form-control>
  </nz-form-item>
</ng-container>

